import React from 'react';
import PropTypes from 'prop-types';
import injectSheet from 'react-jss';
import classNames from 'classnames';

const defaultComponents = {
  label: 'p',
  caption: 'p',
  body1: 'p',
  body2: 'p',
  title: 'h3',
  sectionTitle: 'h3',
  headline: 'h2',
  display1: 'h1',
};

function Typography({
  className,
  classes,
  children,
  type,
  contrast,
  paragraph,
  gutterBottom,
  component,
  componentProps,
  sheet,
  theme,
  ...other
}) {
  const Tag = component || defaultComponents[type];
  const computedClasses = classNames(
    classes.root,
    classes[type],
    contrast && classes.contrast,
    paragraph && classes.paragraph,
    gutterBottom && classes.gutterBottom,
    className,
  );
  return (
    <Tag className={computedClasses} {...componentProps} {...other}>
      {children}
    </Tag>
  );
}

Typography.propTypes = {
  classes: PropTypes.object.isRequired,
  className: PropTypes.string,
  children: PropTypes.node,
  component: PropTypes.string,
  componentProps: PropTypes.object,
  type: PropTypes.oneOf(Object.keys(defaultComponents)),
  contrast: PropTypes.bool,
  paragraph: PropTypes.bool,
  gutterBottom: PropTypes.bool,
  sheet: PropTypes.object,
  theme: PropTypes.object,
};

Typography.defaultProps = {
  className: null,
  children: null,
  component: null,
  componentProps: null,
  type: 'body1',
  contrast: false,
  paragraph: false,
  gutterBottom: false,
  sheet: null,
  theme: null,
};

const stylesheet = theme => ({
  root: {
    margin: 0,
    whiteSpace: 'pre-line',
    color: theme.palette.grey.darkText,
  },
  label: theme.typography.label,
  caption: theme.typography.caption,
  body1: theme.typography.body1,
  body2: theme.typography.body2,
  title: theme.typography.title,
  sectionTitle: theme.typography.sectionTitle,
  headline: theme.typography.headline,
  display1: theme.typography.display1,
  constrast: {
    WebkitFontSmoothing: 'antialiased',
    MozOsxFontSmoothing: 'grayscale',
  },
  paragraph: {
    marginBottom: 3 * theme.spacing.unit,
  },
  gutterBottom: {
    marginBottom: theme.spacing.unit,
  },
});

export default injectSheet(stylesheet)(Typography);



// WEBPACK FOOTER //
// ./src/site-render/src/Typography/Typography.js